import React, { Component } from "react";
import TextInputField from '../atoms/text-input-field'

class PlacesAutocomplete extends Component {
  constructor(props) {
    super(props)
    this.state = {
        elements: this.props.elements,
        street: '',
        street2: '',
        city: '',
        state: '',
        zip: ''
    }

    this.handlePlaceSelect = this.handlePlaceSelect.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.autocomplete = null
  }

  componentDidMount() {
    const google = window.google;
    const options = {
        componentRestrictions: { country: "us" },
        fields: ["address_components"],
    };
    this.autocomplete = new google.maps.places.Autocomplete(document.getElementById('autocomplete'), options);
    this.autocomplete.addListener("place_changed", this.handlePlaceSelect)
  }

  handleChange(event) {
    this.setState({[event.target.name]: event.target.value})
  }

  handlePlaceSelect() {
    let streetNumber, streetAddress, city, state, zip;
    let getAddressObj = this.autocomplete.getPlace();
    let addressObj = getAddressObj.address_components;

    addressObj.map((item, index) => {
        item.types.map((type, index) => {
            if(type === "street_number") {
                streetNumber = item.long_name;
            }
            if(type === "route") {
                streetAddress = item.long_name;
            }
            if(type === "locality") {
                city = item.long_name;
            }
            if(type === "administrative_area_level_1") {
                state = item.short_name;
            }
            if(type === "postal_code") {
                zip = item.short_name;
            }
        })
    })


    this.setState({
      street: `${streetNumber} ${streetAddress}`,
      city: city,
      state: state,
      zip: zip
    })
  }

  render() {
    const createClassList = () => {
        let classList = 'ca-places-autocomplete';
        if (this.props.className) classList = classList + ' ca-places-autocomplete--' + this.props.className;
        if (this.props.classNameJS) classList = classList + ' ' + this.props.classNameJS;
        // if (isRequired) classList = classList + ' js-required';
        return classList;
    };

    const getStates = () => {
        const states = [
            {
                "name": "State",
                "value": "",
                "disabled": true,
                "selected": true
            },
            {
                "name": "Alabama",
                "value": "AL"
            },
            {
                "name": "Alaska",
                "value": "AK"
            },
            {
                "name": "Arizona",
                "value": "AZ"
            },
            {
                "name": "Arkansas",
                "value": "AR"
            },
            {
                "name": "California",
                "value": "CA"
            },
            {
                "name": "Colorado",
                "value": "CO"
            },
            {
                "name": "Connecticut",
                "value": "CT"
            },
            {
                "name": "Delaware",
                "value": "DE"
            },
            {
                "name": "District Of Columbia",
                "value": "DC"
            },
            {
                "name": "Florida",
                "value": "FL"
            },
            {
                "name": "Georgia",
                "value": "GA"
            },
            {
                "name": "Hawaii",
                "value": "HI"
            },
            {
                "name": "Idaho",
                "value": "ID"
            },
            {
                "name": "Illinois",
                "value": "IL"
            },
            {
                "name": "Indiana",
                "value": "IN"
            },
            {
                "name": "Iowa",
                "value": "IA"
            },
            {
                "name": "Kansas",
                "value": "KS"
            },
            {
                "name": "Kentucky",
                "value": "KY"
            },
            {
                "name": "Louisiana",
                "value": "LA"
            },
            {
                "name": "Maine",
                "value": "ME"
            },
            {
                "name": "Maryland",
                "value": "MD"
            },
            {
                "name": "Massachusetts",
                "value": "MA"
            },
            {
                "name": "Michigan",
                "value": "MI"
            },
            {
                "name": "Minnesota",
                "value": "MN"
            },
            {
                "name": "Mississippi",
                "value": "MS"
            },
            {
                "name": "Missouri",
                "value": "MO"
            },
            {
                "name": "Montana",
                "value": "MT"
            },
            {
                "name": "Nebraska",
                "value": "NE"
            },
            {
                "name": "Nevada",
                "value": "NV"
            },
            {
                "name": "New Hampshire",
                "value": "NH"
            },
            {
                "name": "New Jersey",
                "value": "NJ"
            },
            {
                "name": "New Mexico",
                "value": "NM"
            },
            {
                "name": "New York",
                "value": "NY"
            },
            {
                "name": "North Carolina",
                "value": "NC"
            },
            {
                "name": "North Dakota",
                "value": "ND"
            },
            {
                "name": "Ohio",
                "value": "OH"
            },
            {
                "name": "Oklahoma",
                "value": "OK"
            },
            {
                "name": "Oregon",
                "value": "OR"
            },
            {
                "name": "Pennsylvania",
                "value": "PA"
            },
            {
                "name": "Rhode Island",
                "value": "RI"
            },
            {
                "name": "South Carolina",
                "value": "SC"
            },
            {
                "name": "South Dakota",
                "value": "SD"
            },
            {
                "name": "Tennessee",
                "value": "TN"
            },
            {
                "name": "Texas",
                "value": "TX"
            },
            {
                "name": "Utah",
                "value": "UT"
            },
            {
                "name": "Vermont",
                "value": "VT"
            },
            {
                "name": "Virginia",
                "value": "VA"
            },
            {
                "name": "Washington",
                "value": "WA"
            },
            {
                "name": "West Virginia",
                "value": "WV"
            },
            {
                "name": "Wisconsin",
                "value": "WI"
            },
            {
                "name": "Wyoming",
                "value": "WY"
            }
        ]
        let optionFields = states.map((option, index) => (
            <option
                value={option.value}
                disabled={option.disabled ? 'disabled' : null}
                key={index}
            >
                {option.name}
            </option>
        ));
        return optionFields;
    }

    const setupAddressElements = () => {
        let addressElements = [];
        
        // this.state.elements.map((element, index) => {
        //     addressElements.push (
        //         <TextInputField
        //             key={index}
        //             classNameJS="js-show--button"
        //             isRequired={element.required}
        //             isAutoComplete={element.autoComplete}
        //             buttonID={element.buttonID}
        //             inputType={element.type}
        //             inputName={element.name}
        //             inputID={(element.valueType === "streetAddress" ? "autocomplete" : "")}
        //             inputValue={this.state.}
        //             pattern={element.pattern}
        //             placeholder={element.placeholder}
        //             errorMsg={element.errorMessage}
        //             onChange={this.state.onChange}
        //             valueType={element.valueType}
        //             saveResponse={element.submitAPI}
        //         />
        //     )
        // });

        return (
            <div 
            className='ca-places-autocomplete__wrapper'>
                {addressElements}
            </div>
        )
    }

    return(
        <div className={createClassList()} data-button-id={this.props.buttonID}>
            <div className='ca-text-input-field js-required'>
                <div className='ca-text-input-field__wrapper'>
                    <input
                        id="autocomplete"
                        type="text"
                        name="street"
                        placeholder={"Street address"}
                        value={this.state.street}
                        required={true}
                        autoComplete="off"
                        data-save={true}
                        data-value-type="streetAddress"
                        onChange={this.handleChange}
                    />
                    <span className='ca-text-input-field__error-msg'>Please enter a valid street address</span>
                </div>
            </div>
            <div className='ca-text-input-field js-required'>
                <div className='ca-text-input-field__wrapper'>
                    <input
                        type="text"
                        name="street2"
                        placeholder="Apartment, suite, etc. (optional)"
                        value={this.state.street2}
                        required={false}
                        autoComplete="off"
                        data-save={true}
                        data-value-type="streetAddress2"
                        onChange={this.handleChange}
                    />
                </div>
            </div>
            <div className='ca-text-input-field js-required'>
                <div className='ca-text-input-field__wrapper'>
                    <input
                        type="text"
                        name="city"
                        placeholder="City"
                        value={this.state.city}
                        required={true}
                        autoComplete="off"
                        data-save={true}
                        data-value-type="city"
                        onChange={this.handleChange}
                    />
                    <span className='ca-text-input-field__error-msg'>Please enter a valid city</span>
                </div>
            </div>
            <div className="ca-select-field js-required">
                <select
                    name="state"
                    onChange={this.handleChange}
                    value={this.state.state}
                    data-value-type="state"
                    data-save={true}
                >
                    {getStates()}
                </select>
                <span className='ca-select-field__error-msg'>Please enter a valid state</span>
            </div>
            <div className='ca-text-input-field js-required'>
                <div className='ca-text-input-field__wrapper'>
                    <input
                        type="text"
                        name="zip"
                        placeholder="Zip code"
                        value={this.state.zip}
                        required={true}
                        autoComplete="off"
                        data-save={true}
                        data-value-type="zip"
                        onChange={this.handleChange}
                    />
                    <span className='ca-text-input-field__error-msg'>Please enter a valid zip code</span>
                </div>
            </div>
        </div>
        // <div className={createClassList()} data-button-id={this.props.buttonID}>
        //     {setupAddressElements()}
        // </div>
    //   <div>
    //     <input 
    //         id="autocomplete"
    //         // className="input-field"
    //         // ref="input"
    //         type="text"
    //     />
    //     <input 
    //         name={"street"}
    //         value={this.state.street}
    //         placeholder={"Street Address"}
    //         onChange={this.handleChange}
    //     />
    //     <input 
    //         name={"city"}
    //         value={this.state.city}
    //         placeholder={"City"}
    //         onChange={this.handleChange}
    //     />
    //     <input
    //         name={"state"}
    //         value={this.state.state}
    //         placeholder={"State"}
    //         onChange={this.handleChange}
    //     />
    //     <input 
    //         name={"zip"}
    //         value={this.state.zip}
    //         placeholder={"Zipcode"}
    //         onChange={this.handleChange}
    //     />
    //   </div>
    )
  }

}

export default PlacesAutocomplete